module.exports = __webpack_public_path__ + "596fe81003ac71545b5b10707a20b980.jpg";